import { queryOptions, useQuery } from '@tanstack/react-query';

import { SecurityInsightsImageVulnerabilitiesRequest } from '@cast/types';

import { apiClient } from '@cast/infrastructure-api';

type Props = {
  tagId: string;
  packageId?: string;
  enabled?: boolean;
  exceptionFilter?: SecurityInsightsImageVulnerabilitiesRequest['exceptionFilter'];
};

const SECURITY_IMAGE_VULNERABILITIES_QUERY_KEY =
  'security-image-vulnerabilities';

export const getImageVulnerabilitiesQueryKey = (params?: {
  tagId: string;
  packageId?: string;
  exceptionFilter?: string;
}) =>
  params
    ? ([
        SECURITY_IMAGE_VULNERABILITIES_QUERY_KEY,
        params.tagId,
        params.packageId,
        params.exceptionFilter,
      ] as const)
    : ([SECURITY_IMAGE_VULNERABILITIES_QUERY_KEY] as const);

const getImageVulnerabilitiesQueryOptions = ({
  tagId,
  enabled = true,
  packageId,
  exceptionFilter = 'all',
}: Props) =>
  queryOptions({
    queryKey: getImageVulnerabilitiesQueryKey({
      tagId,
      packageId,
      exceptionFilter,
    }),
    queryFn: async () => {
      const { data } = await apiClient.securityInsights.getImageVulnerabilities(
        { tagId, pkgId: packageId, exceptionFilter }
      );
      return data.items || null;
    },
    enabled,
  });

export const useImageVulnerabilitiesQuery = ({
  tagId,
  enabled = true,
  packageId,
  exceptionFilter = 'all',
}: Props) => {
  const {
    isLoading,
    data: vulnerabilities,
    error,
    refetch,
  } = useQuery(
    getImageVulnerabilitiesQueryOptions({
      tagId,
      enabled,
      packageId,
      exceptionFilter,
    })
  );

  return {
    isLoading,
    vulnerabilities: vulnerabilities || undefined,
    error,
    refetch,
  };
};
